// extracted by mini-css-extract-plugin
export var background_1 = "index-module--background_1--fhhvz";
export var background_2 = "index-module--background_2--2Y8k2";
export var background_contain = "index-module--background_contain--WeUDj";
export var body = "index-module--body--gHPgw";
export var cta = "index-module--cta--WErq6";
export var cta_button = "index-module--cta_button--fAwXO";
export var guest = "index-module--guest--LUmoL";
export var guest_list = "index-module--guest_list--gTB7W";
export var guest_list_item = "index-module--guest_list_item--+jptN";
export var guest_list_item_avatar = "index-module--guest_list_item_avatar--gHDC3";
export var guest_list_item_name = "index-module--guest_list_item_name--cgW2T";
export var guest_list_item_title = "index-module--guest_list_item_title--kVUZc";
export var guest_title = "index-module--guest_title--udqkc";
export var guide = "index-module--guide--vJWor";
export var guide_content = "index-module--guide_content--IO60T";
export var guide_content_image = "index-module--guide_content_image--ax+3N";
export var guide_tab = "index-module--guide_tab--I1Oh+";
export var guide_tab_item = "index-module--guide_tab_item--peC9O";
export var guide_tab_item_selected = "index-module--guide_tab_item_selected--Fvrqx";
export var guide_title = "index-module--guide_title--eG9KZ";
export var header = "index-module--header--5yqAM";
export var header_address = "index-module--header_address--O2vVS";
export var header_address_extra = "index-module--header_address_extra--Fs9D+";
export var header_button = "index-module--header_button--g38vq";
export var header_content = "index-module--header_content--IZDrw";
export var header_primary = "index-module--header_primary--EIpE+";
export var header_primaryEnglish = "index-module--header_primaryEnglish--3d26s";
export var header_secondary = "index-module--header_secondary--+jSdS";
export var header_summary = "index-module--header_summary--xroL8";
export var more = "index-module--more--ZWqS4";
export var more_list = "index-module--more_list--wiKmT";
export var more_list_item = "index-module--more_list_item--15eJO";
export var more_list_item_text = "index-module--more_list_item_text--frYI5";
export var navbar = "index-module--navbar--DN5UR";
export var navbar_container = "index-module--navbar_container--2HHKm";
export var navbar_end = "index-module--navbar_end--7-v8I";
export var navbar_end_button = "index-module--navbar_end_button--FdzKC";
export var navbar_end_link = "index-module--navbar_end_link--3Hu4W";
export var navbar_end_link_selected = "index-module--navbar_end_link_selected--Vd3yg";
export var navbar_non_transparent = "index-module--navbar_non_transparent--Ervr+";
export var navbar_start = "index-module--navbar_start--hZlhx";
export var navbar_start_logo_tidb = "index-module--navbar_start_logo_tidb--mjXXC";
export var schedule = "index-module--schedule--CqUIP";
export var schedule_section_list = "index-module--schedule_section_list--oZ4Md";
export var schedule_section_list_item = "index-module--schedule_section_list_item--Cc0By";
export var schedule_section_list_item_end = "index-module--schedule_section_list_item_end--Bl17Q";
export var schedule_section_list_item_end_speakerName = "index-module--schedule_section_list_item_end_speakerName--iDtVi";
export var schedule_section_list_item_end_speakerTitle = "index-module--schedule_section_list_item_end_speakerTitle--i7V3f";
export var schedule_section_list_item_start = "index-module--schedule_section_list_item_start--OgmJl";
export var schedule_section_list_item_start_timeRange = "index-module--schedule_section_list_item_start_timeRange--Ug7v6";
export var schedule_section_list_item_start_title = "index-module--schedule_section_list_item_start_title--LkFFX";
export var schedule_section_list_item_start_title_replay = "index-module--schedule_section_list_item_start_title_replay--YG8Zq";
export var schedule_section_title = "index-module--schedule_section_title--9JmZ2";
export var schedule_section_title_line = "index-module--schedule_section_title_line--Tk997";
export var schedule_title = "index-module--schedule_title--9rFLe";
export var sponsors = "index-module--sponsors---1AfY";
export var sponsors_content = "index-module--sponsors_content--VKvWG";
export var sponsors_section = "index-module--sponsors_section--1bq-K";
export var sponsors_section_list = "index-module--sponsors_section_list--wljMC";
export var sponsors_section_title = "index-module--sponsors_section_title--vFPTj";
export var sponsors_title = "index-module--sponsors_title--W35OD";